import { Box, styled } from '@mui/material'
import { DataGrid, GridCallbackDetails, GridColDef, GridRowParams, MuiEvent } from '@mui/x-data-grid'
import { useState } from 'react'
import { appdata, MaterialInfo } from '../internalModules'
import {Material} from '../internalModules'
import UIMaterialDialog from './UIMaterialDialog'
import { StyledDataGrid, drawerTableStyle } from '../Graphics'

const columns: GridColDef[] = [
  { field: 'category', headerName: 'Category', width: 150 },
  { field: 'name', headerName: 'Material name', width: 360 },
  { field: 'source', headerName: 'Source', width: 130},
  { field: 'gwp', headerName: 'kgCO2e', width: 80 },
  { field: 'units', headerName: 'Unit', width: 60 },
]

type Props = {
  updateApp: Function
}

export default function UIMaterialTable({updateApp}: Props) {

  const [selectedMaterial, setSelectedMaterial] = useState(Material.getEmpty())
  const [dialogOpen, setDialogOpen] = useState(false)
  
  const rows = Array.from(appdata.materials.values()).sort( 
    ( a,b ) => {
      const categoryOrder = a.category.localeCompare(b.category)
      const nameOrder = a.name.localeCompare(b.name)
      return categoryOrder || nameOrder
    }
  ).map( item => {
    return {
      id: item.guid,
      category: item.category,
      name: item.name,
      source: item.source,
      gwp: item.gwp,
      units: item.units,
    }
  })

  function handleRowClick (params: GridRowParams, event: MuiEvent, details: GridCallbackDetails){
    const mat = appdata.getMaterial(String(params.id))
    if(mat.guid === '0'){
      return
    }
    setSelectedMaterial(mat)
    setDialogOpen(true)
  }

/*   function handleDeleteMaterial(guid: string){
    console.log('handle delete')
    appdata.deleteMaterial(guid)
    setDialogOpen(false)
    updateApp()
  } */

  const toggleDialogOpen = (open: boolean) => (event: React.MouseEvent) => {
    setDialogOpen(open)
  }

  const handleAcceptDialog = (info: MaterialInfo) => {
    appdata.setMaterialInfo(info.guid, info)
    setDialogOpen(false)
    updateApp()
  }

  return (
    <>
      <div style={drawerTableStyle}>
        <StyledDataGrid
          rows={rows}
          columns={columns}
          pageSize={90}
          rowsPerPageOptions={[90]}
          density='compact'
          onRowClick={handleRowClick}
          hideFooter
        />
      </div>
      <UIMaterialDialog key={selectedMaterial.guid + 'edit'} materialGuid={selectedMaterial.guid}
        isOpen={dialogOpen} closeDialog={toggleDialogOpen(false)}
        acceptDialog={handleAcceptDialog} />
    </>
  )
}